import fly from "../config/flyio";
export default{
    getSummaryModelListData(appNo){
        return fly.get(`/VHISLoveYourSelf/GetGlobalSummaryModel?appNo=${appNo}`);
    }
};